import { Component, input } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { DoorBellData } from "src/app/interfaces/interfaces";
import { ModalStateService } from "src/app/services/modal-service/modal-state.service";

@Component({
  selector: "app-additional-subj-modal",
  templateUrl: "./additional-subj-modal.page.html",
  styleUrls: ["./additional-subj-modal.page.scss"],
  standalone: true
})
export class AdditionalSubjModalPage {
  readonly sub = input.required<DoorBellData[]>();
  readonly isEmpPIN = input.required<boolean>();
  readonly EmpPIN = input.required<string>();

  language: "DE" | "EN";

  constructor(
    private modalState: ModalStateService,
    private translateService: TranslateService
  ) {
    if (this.translateService.currentLang === "de") {
      this.language = "DE";
    } else {
      this.language = "EN";
    }
  }

  setLanguage(language: "DE" | "EN") {
    this.language = language;
  }

  get titleText(): string {
    return this.language === "DE"
      ? "Bitte Anliegen auswählen."
      : "Please select your concern.";
  }

  get employeeButtonText(): string {
    const translationKey = `MODAL.HEADER.EMPLOYEEPIN.${this.language}`;
    return this.translateService.instant(translationKey);
  }

  getItemTitle(item: DoorBellData): string {
    if (!item?.title) return "";
    return this.language === "DE" ? item.title.de : item.title.en;
  }

  selectItem(item: DoorBellData): void {
    let message = "";

    if (item?.message) {
      message = this.language === "DE" ? item.message.de : item.message.en;
    }

    this.closeModal(this.language, message, item._id);
  }

  employee() {
    this.closeModal(this.language, "employee", "");
  }

  closeModal(language: "DE" | "EN", reason: string, id: string) {
    const data = { message: reason, id: id };
    this.modalState.triggerDismiss(language, data);
  }
}
